import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';

// Fails closed: an absent flag means OFF everywhere, so an unfinished feature is never exposed.
// Uses the deprecated useDarkly() because `dailyBriefing` isn't in the generated OcDarklyFlags yet.
export function useDailyBriefingEnabled(): boolean {
  const { dailyBriefing } = useDarkly();
  return dailyBriefing ?? false;
}
